import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  PointsExpiry as PointsExpiryComponent,
  PointsExpiryProps,
} from "../../components/PointsExpiry/PointsExpiry";
import { getLedgerHead as getLedgerHeadAction } from "../../actions";
import { StoreState } from "../../reducers";
import { getLedgerHead, getRewardRequestStatus } from "../../reducers/methods";
import { customerAuthenticationOccurred } from "../../utils/customer";

interface PointsExpiryContainerProps extends PointsExpiryProps {
  getLedgerHeadAction: typeof getLedgerHeadAction;
  ledgerHead: ReturnType<typeof getLedgerHead>;
  requestStatus: ReturnType<typeof getRewardRequestStatus>;
  currency?: string;
}

class PointsExpiry extends React.Component<PointsExpiryContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (
      isCustomerAuthenticated &&
      this.props.requestStatus.getLedger !== "REQUESTING"
    ) {
      const { currency } = this.props;

      if (!currency) {
        throw new Error(
          "Currency is undefined. Please provide a valid currency."
        );
      }

      this.props.getLedgerHeadAction({ currency });
    }
  }

  componentDidUpdate(prevProps: PointsExpiryContainerProps) {
    if (customerAuthenticationOccurred(prevProps.data, this.props.data)) {
      const { currency } = this.props;

      if (!currency) {
        throw new Error(
          "Currency is undefined. Please provide a valid currency."
        );
      }

      this.props.getLedgerHeadAction({ currency });
    }
  }

  render() {
    return <PointsExpiryComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  ledgerHead: getLedgerHead(state),
  requestStatus: getRewardRequestStatus(state),
});

export default connect(mapStateToProp, {
  getLedgerHeadAction,
})(PointsExpiry);
